/**
 * Sets the TCPA text to match the submit button text
 */
export function setTCPAText() {
  const submitCTA =
    /** @type{HTMLButtonElement | null} */ document.querySelector(
      'button[type="submit"]',
    )
  if (submitCTA) {
    const ctaLabel = submitCTA.textContent || ''
    const legalCTAText =
      /** @type{HTMLSpanElement | null} */ document.getElementById(
        'legal-cta-label-l6vfi2',
      )
    if (legalCTAText) {
      legalCTAText.innerHTML = ctaLabel
    }
  }
}
